import React from "react";
import { cx } from "styled-system/css";
import { container, input, track, trackChecked, thumb, thumbChecked } from "./switch.styles";

interface SwitchProps extends React.InputHTMLAttributes<HTMLInputElement> {
  className?: string;
}

export const Switch = React.forwardRef<HTMLInputElement, SwitchProps>(
  ({ className, checked, ...props }, ref) => {
    return (
      <label className={cx(container, className)}>
        <input type="checkbox" ref={ref} checked={checked} className={input} {...props} />
        <div className={cx(track, checked && trackChecked)}>
          <div className={cx(thumb, checked && thumbChecked)} />
        </div>
      </label>
    );
  },
);

Switch.displayName = "Switch";
